module.exports = __webpack_public_path__ + "assets/img/flipper.d19dbffa.png";